import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Genre } from "../model/genre";

@Injectable({
    providedIn: 'root'
  })
  export class NetworkGenreService {

    constructor(private http: HttpClient) {}

    setNetworkGenresRelation(networkId: number, genreIds: number[]): Observable<any> {
      return this.http.post<any>(`${environment.apiDomainSetNetworkGenreRelation}/${networkId}`, genreIds);
    }

    updateNetworkGenresRelation(networkId: number, genreIds: number[]): Observable<any> {
        return this.http.post<any>(`${environment.apiDomainPutNetworkGenreRelation}/${networkId}`, genreIds);
      }

    getGenresByNetwork(networkId: number): Observable<any> {
        return this.http.get<any>(`${environment.apiDomainGetGenresForNetwork}/${networkId}`);
    }
  }
